import { useState } from 'react'
import { Button, Tooltip } from '@boltenergy-be/design-system'
import styles from './ConfirmationTooltip.module.scss'
import { ConfirmationTooltipProps } from './types'

const ConfirmationTooltip = ({ label, confirmation, children, onConfirm, disabled, isLoading }: ConfirmationTooltipProps) => {
  const [open, setOpen] = useState(false)
  const [prevIsLoading, setPrevIsLoading] = useState(isLoading)

  // Close the tooltip once the confirmation's mutation finishes
  if (isLoading !== prevIsLoading) {
    setPrevIsLoading(isLoading)
    if (!isLoading) setOpen(false)
  }

  return (
    <Tooltip
      tooltipContent={
        <div className={styles['confirmation-tooltip']}>
          <small>{label}</small>
          <Button onClick={onConfirm} loading={isLoading} className={styles.confirmation}>
            {confirmation}
          </Button>
        </div>
      }
      tooltipContentClassName={styles.tooltip}
      open={open}
      onOpenChange={setOpen}
      asChild
    >
      <Button variant="tertiary" disabled={disabled} onClick={() => setOpen(true)}>
        {children}
      </Button>
    </Tooltip>
  )
}

export default ConfirmationTooltip
